module.exports = __webpack_public_path__ + "static/img/checkboxfill.cdec781e.jpg";